import { INVALID_MODULE, LabeledModule } from "./base";
import { SurveyConfigModule, ModuleType } from "../fanApp";
import { LabeledBuilderConfigModule, QuestionEditProps } from "../creator";

export class HTMLModule extends LabeledModule {
  protected _type: ModuleType = "Html";

  validate(): this is Required<HTMLModule> {
    return true;
  }

  toBuilderConfig(): LabeledBuilderConfigModule {
    if (this.validate()) {
      const builderConfigModule: LabeledBuilderConfigModule = {
        id: this.id,
        label: this.label,
        style: this.style,
        stylesheet: this.stylesheet ?? "",
        type: this.type,
      };

      if (this.className) {
        builderConfigModule.className = this.className;
      }

      if (this.tag) {
        builderConfigModule.tag = this.tag;
      }
      return builderConfigModule;
    }

    throw new Error(INVALID_MODULE(this));
  }

  toSurveyConfig(): SurveyConfigModule {
    const { label, stylesheet, ...rest } = this.toBuilderConfig();

    return {
      ...rest,
      actionRequired: this.actionRequired,
      // on error, sanitized html is null, so we can combine error handling
      content: label?.[this.languageCode] ?? "",
      stylesheet: stylesheet ?? "",
    };
  }

  editProps(): QuestionEditProps {
    return {
      id: this.id,
      hidden: this.hidden,
      type: this.type,
      question: this.label[this.languageCode] ?? "",
      actionRequired: this.actionRequired,
    };
  }
}
